module.exports = __webpack_public_path__ + "static/presidents-message-5f1c95a2c29fe158e1dfb14cd9e8a147.jpg";